/**
 * Listens to window resize event in an optimized way.
 */
function observeViewportResize(callback: () => void, preferPassive = false) {
  let timeout: number | undefined;

  const onFrame = () => callback();

  function onResize() {
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }

    // don't fire the callback more often than once per each rendered frame
    timeout = window.requestAnimationFrame(onFrame);
  }

  window.addEventListener('resize', onResize, { passive: preferPassive });

  function stopObserving() {
    window.removeEventListener('resize', onResize);
  }

  return { stopObserving };
}

export { observeViewportResize };
